import type { TOC } from '@ember/component/template-only';
import { PrismBadge } from '@mylighthouse/prism-ember';
import type { BadgeType } from '@mylighthouse/prism-ember/types/components/prism/badge';

interface TransactionCellsTdStatusSignature {
  Args: {
    value: {
      badgeType: BadgeType;
      formattedStatus: string;
    };
  };
}

const TransactionCellsTdStatus = <template>
  <PrismBadge @label={{@value.formattedStatus}} @type={{@value.badgeType}} />
</template> satisfies TOC<TransactionCellsTdStatusSignature>;

export default TransactionCellsTdStatus;
